export default __webpack_public_path__ + "static/media/category.38215915.svg";